import { symbol } from "./symbol.js";
<ebay-icon ...input _name="chevron-down-12" _size="12" _type="icon" _themes=symbol/>